import { useAuthStore } from "@store/authStore";
import { useHotelStore } from "@store/hotelStore";
import type { SectionName, SectionPermissions } from "@/types/user";

/**
 * Hook that resolves the current user's permissions for the selected hotel.
 * Superadmins get full access to everything.
 */
export function usePermissions() {
  const user = useAuthStore((s) => s.user);
  const selectedHotelId = useHotelStore((s) => s.selectedHotelId);

  const isSuperadmin = user?.is_superadmin ?? false;

  // Find the hotel role for the selected hotel
  const hotelRole = user?.hotels.find((h) => h.hotel_id === selectedHotelId);
  const perms: SectionPermissions = hotelRole?.section_permissions ?? {};

  function canRead(section: SectionName): boolean {
    if (isSuperadmin) return true;
    return perms[section]?.read ?? false;
  }

  function canWrite(section: SectionName): boolean {
    if (isSuperadmin) return true;
    return perms[section]?.write ?? false;
  }

  return { canRead, canWrite, isSuperadmin, permissions: perms };
}
